export default {"src":"/_next/static/media/vscode.e905ee61.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};